import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { getMerchantDeals } from "../../../redux/actions/voucherActions";
import moment from "moment";
import auth from "../../../services/auth";
import ReactHtmlParser from "react-html-parser";
import { getContractPoposal } from "../../../redux/actions/contractActions";

const history = createBrowserHistory();

let isLoading = "false",
  userID = "";
class View extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "View Contract"],
      contractData: "",
      show: false,
      alertMessage: "",
      deallist: "",
      contractDetails: "",
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    this.setState({ contractData: "" });
    this.handleDismiss();
    this.props.clearAlert();
    if (e.target.value !== "") {
      isLoading = "true";
      let contractIdParams = e.target.value;
      this.props.getContractPoposal(contractIdParams);
    }
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    isLoading = "true";
    userID = this.props.match.params.userID
      ? this.props.match.params.userID
      : "";
    if (userID !== "") {
      this.props.getMerchantDeals(userID, {page: 0});
    } else {
      const userinfo = auth.getUserInfo();
      if (userinfo.user_id !== "") {
        isLoading = "true";
        this.props.getMerchantDeals(userinfo.user_id, {page: 0});
      }
    }
  }

  componentWillReceiveProps(nextProps) {
     if(this.props.contractDetails !== nextProps.contractDetails){
      if(nextProps.contractDetails){
        this.setState({contractDetails: nextProps.contractDetails.data});
        isLoading = "false";
      }
    }

    if (this.props.merchantdealList !== nextProps.merchantdealList) {
      if (nextProps.merchantdealList) {
        isLoading = "false";
        this.setState({ deallist: nextProps.merchantdealList.data });
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      //Clear();
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  render() {
    let dealListItems;
    let dealListData = this.state.deallist ? this.state.deallist : [];
    if (dealListData !== "") {
      dealListItems = dealListData.map((el, key) => (
        <option key={key} value={el.contractID}>
          {el.dealText}
        </option>
      ));
    }

    let contract = this.state.contractData ? this.state.contractData : {};
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 text-right">
            <Button
              bsSize="small"
              bsStyle="success"
              onClick={() => this.context.router.history.push(`/merchant/dashboard/${userID}`)}
            >
              Back
            </Button>
          </div>
        </div>

        <div className="row">
          {this.state.show &&
            this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
          <div className="col-lg-12 text-center">
            <FormGroup controlId="formdeallist">
              <ControlLabel>Select Your Offer</ControlLabel>
              <FormControl
                componentClass="select"
                name="dealID"
                onChange={this.handleChange}
                value={this.state.dealID}
              >
                <option value="">Select your offer</option>
                {dealListItems}
              </FormControl>
            </FormGroup>
          </div>
        </div>

        <div className="clearfix" />

        {this.state.contractDetails !== "" ? (
          <div id="divdeal" className="row">
            <div className="panel">
              <header className="panel-heading">Contract Detail</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={12} xs={12}>
                      {this.state.contractDetails ? ReactHtmlParser(this.state.contractDetails) : ''}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    contractDetails: state.contractReducer.contractDetail,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantdealList: state.voucherReducer.merchantdealList,
    error: state.dealReducer.error
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getContractPoposal,
    getMerchantDeals
  })
)(View);



// WEBPACK FOOTER //
// ./src/app/views/merchant/contract/View.js